import pl from './lang/pl';

export interface IEmitterOptionsImage {
  uploadURL: string;
  dropzoneOptions: any;
}

export interface IEmitterOptions {
  image: IEmitterOptionsImage;
  hideModules: any;
  paragraphSeparator: string;
  maxHeight?: number;
  customModules: any[];
  lang: any;
}
export class EmitterUtils {
  public getHTMLOfSelection(): string {
    if (window.getSelection !== undefined) {
      const selection = window.getSelection();
      if ((selection) && (selection.rangeCount > 0)) {
        const clonedSelection = selection.getRangeAt(0).cloneContents();
        const div = document.createElement('div');
        div.appendChild(clonedSelection);
        return div.innerHTML;
      }
    }

    return '';

  }
}
const utils = new EmitterUtils();

// tslint:disable-next-line: max-classes-per-file
class Emitter {
  public listeners: any;
  public options: IEmitterOptions;
  public utils: EmitterUtils;



  constructor() {
    this.listeners = {};
    this.options = {
      image: {
        uploadURL: 'None',
        dropzoneOptions: {}
      },
      hideModules: {},
      paragraphSeparator: 'div',
      maxHeight: undefined,
      customModules: [],
      lang: pl
    };
    this.utils = utils;
  }
  public on(eventName: string, handler: any) {
    if (this.listeners[eventName] === undefined) {
      this.listeners[eventName] = [];
    }
    this.listeners[eventName].push(handler);
  }
  public emit(eventName: string, ...args: any[]) {
    if (this.listeners[eventName] !== undefined) {
      this.listeners[eventName].forEach((handler: any) => handler.apply(args));
    }
  }
}



const emitter = new Emitter();



export default emitter;
